import domain from './domain';

export interface ISessionConfig {
  idleTimeout: number,
  prolongInterval: number,
  viewerIdTtl: number,
  loginEndpoints: string[],
}

const sessionConfig: ISessionConfig = {
  idleTimeout: 5 * 60 * 1000, // 5m in ms
    prolongInterval: 15 * 60 * 1000, // 15m in ms
  viewerIdTtl: 10 * 30 * 24 * 60 * 60 * 1000, // 10mo in ms,
  loginEndpoints: [
  `${ domain.protocol }//${ domain.dealroadshowDomain }`,
  `${ domain.protocol }//${ domain.usersDomain }/login`,
  `${ domain.protocol }//${ domain.usersDomain }/login/condor`,
  `${ domain.protocol }//${ domain.condorDomain }/login/condor`,
  ],
};

export default sessionConfig;
